import Swiper, { Pagination, Navigation } from "swiper";

import "Layouts/shopping";

import "Ui/tabs";
import "Ui/toggle";
import "Ui/slider";
import "Components/form/vouchers";

import "./shopping-cart-jquery";
import "Common/cart-custom";

rEvent.on("Cart.product.after_add", function (response) {
    if (response.status) {
        window.location.reload();
    }
});

document.addEventListener("DOMContentLoaded", function () {
    const updateQuantity = (event) => {
        const rSpinner = event.detail.rSpinner;
        const quantity = rSpinner.getParsedValue();
        const oldValue = rSpinner.getParsedOldValue();
        const max = rSpinner.max;
        const spinDirection = rSpinner.spinDirection;

        if (
            (quantity == oldValue && quantity == max && spinDirection == "up") ||
            (quantity == max && spinDirection === null)
        ) {
            Eshop.tippyAlert(
                rSpinner.input,
                rSpinner.dataset.maxMessage.replaceAll(":productStock", rSpinner.max),
                {
                    theme: "warning",
                },
                20 * 1000
            );
        }

        // promotion spinners
        if (rSpinner.classList.contains("js-product-quantity-spinner")) {
            const promotionSpinners = rSpinner
                .closest(".c-cart-products__row")
                .querySelectorAll(".js-promotion-quantity-spinner");

            if (promotionSpinners && quantity != oldValue) {
                promotionSpinners.forEach((promotionSpinner) => {
                    promotionSpinner.querySelector(".c-form__input").setAttribute("max", quantity);
                });
            }
        }
    };
    for (const rSpinner of document.querySelectorAll("r-spinner")) {
        rSpinner.addEventListener("stop", updateQuantity);
        rSpinner.addEventListener("changed", updateQuantity);
    }
});

rEvent.on("Cart.after.updateQuantity", function (input, response) {
    if (response) {
        const parentProductId = response.item.id;
        const products = response.products;

        // update promotion spinners
        const matchingProducts = Object.values(products).filter((product) => {
            return product.id.endsWith("COMBIDEAL-" + parentProductId);
        });

        matchingProducts.forEach((product) => {
            const promotionProduct = document.querySelector(
                `.js-promotion-item[data-cart-id="${product.id}"]`
            );

            if (promotionProduct) {
                const currentQuantity = promotionProduct.querySelector(
                    ".js-promotion-quantity-spinner"
                ).input.value;
                const newQuantity = product.quantity;

                if (currentQuantity != newQuantity) {
                    promotionProduct.querySelector(".js-promotion-quantity-spinner").input.value =
                        newQuantity;
                    $(
                        promotionProduct.querySelector(".js-promotion-quantity-spinner").input
                    ).change();
                }
            }
        });

        // update product type totals
        const typeId = products[parentProductId].product_type_id;
        const triggerElem = document.querySelector(`.js-type-trigger[data-tab-id="tab-${typeId}"]`);

        if (triggerElem) {
            const productsAsArray = Object.entries(products);
            const filteredProductsArray = productsAsArray.filter(
                ([key, value]) => value.product_type_id === typeId
            );
            const typeFinalPrice = filteredProductsArray.reduce(
                (acc, [key, value]) => acc + value.price_vat * value.quantity,
                0
            );
            const typeFinalPriceFormatted = Format.price(typeFinalPrice);

            triggerElem.querySelector(".js-type-total").innerHTML = typeFinalPriceFormatted;
            // aby bolo jasne, moze nastat situacia ked darcek bude mat iny typ produktu ako skupina v ktorej sa nachadza jeho parent (produkt ku ktoremu je darcek)
            // vtedy to tu nebude fungovat, ale to je ok, lebo to je edge case
        }
    }
});

rEvent.on("Cart.totals.after_updated", function (data) {
    if (data.rounding) {
        $('[data-element="cart"]')
            .filter('[data-type="rounding"]')
            .html(Format.price(data.rounding));
    }

    if (data.savings) {
        $('[data-element="cart"]').filter('[data-type="savings"]').html(Format.price(data.savings));
    }
});

// quick shopping
$(".js-shopping-model").validate();

$(".js-shopping-model").on("keypress", function (event) {
    const isEnter = event.key == "Enter";

    if (isEnter && $(event.target).hasClass("js-model-number")) {
        event.preventDefault();

        $(".js-model-quantity").focus();
    }
});

$(".js-shopping-model").on("submit", function (event) {
    event.preventDefault();
    const $form = $(this);
    const $submit = $form.find('button[type="submit"]');
    $submit.addClass("is-loading");

    const model = $form.find("[name=model]").val();
    const quantity = $form.find("[name=quantity]").val();
    var isInCart = false;

    Cart.getItemsRequest((res) => {
        $submit.removeClass("is-loading");
        isInCart = Object.values(res.data.items).some((item) => item.model === model);

        if (isInCart) {
            const $modalForm = $("form[name=form-cart-check]");
            $modalForm.find("[name=model]").val(model);
            $modalForm.find("[name=quantity]").val(quantity);

            $("#cart-check").modal("show");
        } else {
            $form.off("submit").submit();
        }
    });
});

if (
    window.location.search.indexOf("model") == 1 &&
    document.getElementsByClassName("js-model-number").length
) {
    if (!$(".shopping-quick__header").hasClass("is-active")) {
        $(".shopping-quick__header").click();
    }

    setTimeout(function () {
        $(".js-model-number").focus().select();
    }, 250);
}

if ($('input[name="payment_id"][data-disabled="true"]:checked').length) {
    $('input[name="payment_id"][data-disabled="true"]:checked')
        .prop("checked", false)
        .trigger("change");
}

$(".js-import-form-input").on("change", function () {
    $(".js-import-form").submit();

    $(this).prop("disabled", true);
    $(this).siblings(".c-btn").addClass("is-loading");
});

$(".js-shopping-model").validate();

$(".js-shopping-model").on("keypress", function (event) {
    const isEnter = event.key == "Enter";

    if (isEnter && $(event.target).hasClass("js-model-number")) {
        event.preventDefault();

        $(".js-model-quantity").focus();
    }
});

$(".js-shopping-model").on("submit", function (event) {
    event.preventDefault();
    const $form = $(this);
    const $submit = $form.find('button[type="submit"]');
    $submit.addClass("is-loading");

    const model = $form.find("[name=model]").val();
    const quantity = $form.find("[name=quantity]").val();
    var isInCart = false;

    Cart.getItemsRequest((res) => {
        $submit.removeClass("is-loading");
        isInCart = Object.values(res.data.items).some((item) => item.model === model);

        if (isInCart) {
            const $modalForm = $("form[name=form-cart-check]");
            $modalForm.find("[name=model]").val(model);
            $modalForm.find("[name=quantity]").val(quantity);

            $("#cart-check").modal("show");
        } else if (model !== "") {
            $form.off("submit").submit();
        }
    });
});

$("#import_input").on("change", function () {
    $(".js-import-form").submit();

    $(this).prop("disabled", true);
    $(this).siblings(".c-btn").addClass("is-loading");
});

$(".js-close-csv-msg").on("click", function () {
    console.log("click");
    $(this).closest(".c-msg").hide();
});

$(".js-print").on("click", function (event) {
    event.preventDefault();
    window.print();
});

// Product customer note
$(".js-note-trigger").on("click", function (event) {
    event.preventDefault();

    const { cartId } = this.dataset;
    const target = document.querySelector(`.js-note-target[data-cart-id="${cartId}"]`);
    const isActive = target.classList.toggle("is-active");
    const noteInput = target.querySelector(".js-note-input");

    this.classList.toggle("is-active", isActive);

    if (isActive) {
        noteInput.focus();
    } else {
        noteInput.lastValue = noteInput.value;
        noteInput.value = null;
        $(noteInput).trigger("change");
    }
});

let noteTimeout = null;
$(".js-note-input").on("keyup keypress blur change", function (event) {
    const isEnter = event.keyCode == 13;

    if (isEnter) {
        this.blur();
        return;
    }

    const { notePostUrl } = this.dataset;
    const $noteTarget = $(this).closest(".js-note-target");
    $noteTarget.addClass("is-loading");

    if (this.lastValue === undefined) {
        this.lastValue = this.value;
    }

    window.clearTimeout(noteTimeout);

    noteTimeout = window.setTimeout(
        () => {
            if (this.value != this.lastValue) {
                $.post(
                    notePostUrl,
                    { note: this.value },
                    (response) => $noteTarget.removeClass("is-loading"),
                    "json"
                );
            } else {
                $noteTarget.removeClass("is-loading");
            }

            this.lastValue = this.value;
        },
        ["change", "blur"].includes(event.type) ? 0 : 500
    );
});
